import { Alias } from './aliases';
import { ArrayKeyMapper } from './array-key-mapper';
import { KeyMapper } from './key-mapper';
import { ObjectKeyMapper } from './object-key-mapper';

export class WrapperKeyMapper {
  readonly #keyMapper: KeyMapper;
  readonly #objectKeyMapper: ObjectKeyMapper;
  readonly #arrayKeyMapper: ArrayKeyMapper;

  constructor(aliases: Alias[]) {
    this.#keyMapper = new KeyMapper(aliases);
    this.#objectKeyMapper = new ObjectKeyMapper(this.#keyMapper);
    this.#arrayKeyMapper = new ArrayKeyMapper(this.#objectKeyMapper);
  }

  // Agregamos método add delegando a KeyMapper
  add(internal: string, external: string): void;
  add(alias: Alias): void;
  add(internalOrAlias: string | Alias, external?: string): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.#keyMapper.add(internalOrAlias as any, external as any);
  }

  toExternal<TType>(value: TType): TType {
    if (Array.isArray(value)) {
      return this.#arrayKeyMapper.toExternal(value) as TType;
    } else if (this._isRecord(value)) {
      return this.#objectKeyMapper.toExternal(value) as TType;
    } else if (typeof value === 'string') {
      return this.#keyMapper.toExternal(value) as TType;
    } else {
      return value;
    }
  }

  toInternal<TType>(value: TType): TType {
    if (Array.isArray(value)) {
      return this.#arrayKeyMapper.toInternal(value) as TType;
    } else if (this._isRecord(value)) {
      return this.#objectKeyMapper.toInternal(value) as TType;
    } else if (typeof value === 'string') {
      return this.#keyMapper.toInternal(value) as TType;
    } else {
      return value;
    }
  }

  private _isRecord(value: unknown): value is Record<string, unknown> {
    return (
      typeof value === 'object' &&
      value !== null &&
      Object.prototype.toString.call(value) === '[object Object]'
    );
  }
}
